import React, { useEffect } from 'react';
import SearchIcon from '../../../../ui/svg/common/search';
import Wrapper from './wrapper';
import { useDispatch } from 'react-redux';
import { rootActions, useAppSelector } from '../data/store';

const SiteHeaderSearchMobile = () => {

    const dispatch = useDispatch();
    const isOpened = useAppSelector(store => store.root.isOpened);

    useEffect(() => {
        const $root = document.getElementById('header-search-m-placeholder');
        if(!$root) return;

        $root.classList.toggle('top-search-m__opened', isOpened);
    }, [isOpened]);

    const toggle = () => {
        dispatch(
            rootActions.main({
                isOpened: !isOpened,
            })
        )
    };

    return (
        <section className="relative flex items-center">
            <button type="button" className="w-4 mr-6" onClick={ toggle }>
                <SearchIcon width="100%" height="100%" color="#ffffff" title="Search" />
            </button>

            <Wrapper />
        </section>
    )
};

export default SiteHeaderSearchMobile;